/** Parcel 本地 dev 路由归一化：必须在 React Router 启动前执行。 */
import { isMobileDevice } from './device.js';

function redirectMobileChatPxToPxm(search, hash) {
  if (!isMobileDevice()) return false;
  window.location.replace(`/chatPXM${search}${hash}`);
  return true;
}

export function normalizeSpaPathBeforeBoot() {
  if (typeof window === 'undefined') return;
  const { pathname, search, hash } = window.location;

  // /chatPXM.html?code= → /chatPXM?code=（避免 Router 路径不匹配）
  const htmlRoute = pathname.match(/^\/(chatPXM|chatPX|chatMT|chatYL|chatPX3D)\.html$/i);
  if (htmlRoute) {
    const route = htmlRoute[1];
    if (route.toLowerCase() === 'chatpx' && redirectMobileChatPxToPxm(search, hash)) {
      return;
    }
    window.history.replaceState(
      {},
      '',
      `/${route}${search}${hash}`,
    );
    return;
  }

  // 移动端不应进入桌面培训页，避免登录后闪一下旧界面
  if (/^\/chatPX\/?$/i.test(pathname) && redirectMobileChatPxToPxm(search, hash)) {
    return;
  }

  // 根路径或 index.html 带班级码 → 学员移动端入口
  const params = new URLSearchParams(search);
  const hasClassCode =
    params.get('code') ||
    params.get('Code') ||
    params.get('enroll') ||
    params.get('classId');
  if (
    hasClassCode &&
    (pathname === '/' || pathname === '/index.html' || pathname.endsWith('/index.html'))
  ) {
    window.history.replaceState({}, '', `/chatPXM${search}${hash}`);
  }
}
